// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"70a6e6f8","80":"50b42f9f","380":"75de3a40","418":"13724b26","765":"a1d0c1c5","856":"42c942cf"}[chunkId] + ".chunk.js";
};